import { createMemoryHistory, createRouter } from 'vue-router'
import MainScreen from "@/components/MainScreen.vue"
import PlayersLounge from "@/components/players/PlayersLounge.vue"
import PlayerScreen from "@/components/players/PlayerScreen.vue"
import PlayersRoom from "@/components/players/PlayersRoom.vue"
import BokkerijenGame from "@/components/card-games/BokkerijenGame.vue"
import HartenjagenGame from "@/components/card-games/HartenjagenGame.vue"
import RummikubGame from "@/components/card-games/RummikubGame.vue"
import DartenGame from "@/components/card-games/DartenGame.vue"
import PlayScreen from "@/components/PlayScreen.vue";
import KlaverjasGame from "@/components/card-games/KlaverjasGame.vue";

const routes = [
    { path: '/', component: MainScreen },
    { path: '/lounge', component: PlayersLounge },
    { path: '/player', component: PlayerScreen },
    { path: '/spelen', component: PlayScreen },
    { path: '/tafel', component: PlayersRoom },
    { path: '/bokkerijen', component: BokkerijenGame },
    { path: '/hartenjagen', component: HartenjagenGame },
    { path: '/rummikub', component: RummikubGame },
    { path: '/darten', component: DartenGame },
    { path: '/klaverjas', component: KlaverjasGame },
]

export default createRouter({
    history: createMemoryHistory(),
    routes,
})